import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';

export default class Register extends RetailModel {
  /**
   * Exports the GatewayType
   */
  static get TerminalType() {
    return _TerminalType;
  }

  // Server uses the registerID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'registerID';
  }

  get defaults() {
    return {
      name: '',
      open: false,
      openTime: '',
      archived: false,
      openEmployeeID: 0,
      shopID: 0,
      ccTerminalID: '',
    };
  }

  get retailResponseName() {
    return 'Register';
  }

  /**
   * Return the url for the Register endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/Register');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let register = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    register.registerID = Format.parseInt(register.registerID);
    register.open = Format.parseBoolean(register.open);
    register.archived = Format.parseBoolean(register.archived);
    register.openEmployeeID = Format.parseInt(register.openEmployeeID);
    register.shopID = Format.parseInt(register.shopID);

    if (register.ccTerminalID && register.ccTerminalID.match && !register.ccTerminalID.match(/-/)) {
      // the ID may be a UUID for certain types of terminals (e.g. Blackline)
      register.ccTerminalID = Format.parseInt(register.ccTerminalID);
    }

    return register;
  }
}
